export default {
  message: {
    "strid1": "Gabung",
    "strid2": "Pengumuman",
    "strid3": "Lebih",
    "strid4": "Penyelidikan penalti",
    "strid5": "Laporkan pertanyaan",
    "strid6": "Pengumuman penalti",
    "strid7": "Ilmu Keamanan",
    "strid8": "Aturan hukuman",
    "strid9": "Laporkan waktu",
    "strid10": "Laporkan pemain",
    "strid11": "Laporkan alasannya",
    "strid12": "Laporkan hasil",
    "strid13": "Diterima",
    "strid14": "Pelanggaran",
    "strid15": "Waktu penalti",
    "strid16": "Alasan hukuman",
    "strid17": "Membatalkan pemblokiran waktu",
    "strid18": "Menarik",
    "strid19": "Banding",
    "strid20": "Memverifikasi",
    "strid21": "Banding gagal",
    "strid22": "Hasil banding",
    "strid23": "Banding berhasil",
    "strid24": "cepat",
    "strid25": "Formulir Banding",
    "strid26": "Kemungkinan alasan hukuman",
    "strid27": "Alamat unduhan perangkat lunak video / gambar / plug-in",
    "strid28": "Deskripsi",
    "strid29": "sistem swalayan",
    "strid30": "Nama panggilan",
    "strid31": "ID Akun",
    "strid32": "Tingkat",
    "strid33": "Pangkat",
    "strid34": "Durasi Permainan",
    "strid35": "Model telepon",
    "strid36": "Kotak surat",
    "strid37": "Binding AccountID （google, fb atau vk）",
    "strid38": "Sebelum mengajukan banding, Anda perlu mengisi informasi akun dan informasi kontak Anda agar kami dapat menghubungi Anda",
    "strid39": "Akun saya dicuri.",
    "strid40": "Saya tidak curang, akun saya hanya digunakan oleh saya.",
    "strid41": "Saya akui bahwa saya curang dan saya tidak akan melakukannya lagi.",
    "strid42": "Silakan masuk ",
    "strid43": "Hubungi Layanan Pelanggan",
    "strid44": 'aku tahu',
    "strid45": 'Tidak ',
    "strid46": 'Harap lengkapi formulirnya',
  }
}

